import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

import { keyboard$ } from '../keyboard';

@Component
export class BarcodeReader extends ReactiveVue {
    public created() {
        this.subscribeTo(keyboard$, input => {
            this.$emit('input', input);
        });
    }

    public render() {
        return null;
    }
}
